module.exports = __webpack_public_path__ + "static/media/trasparent_logo.0658becf.png";